import { render } from "./HelpPageComponent.vue?vue&type=template&id=11a80fb2"
import script from "./HelpPageComponent.vue?vue&type=script&lang=js"
export * from "./HelpPageComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__